<div class="bg-[#232323] text-white w-full min-h-[60vh] flex flex-col">
    <!-- Cabeçalho -->
    <div class="px-6 md:px-16 pt-8">
        <h1 class="text-2xl md:text-3xl font-bold">Aulas ao vivo</h1>
        <p class="text-sm md:text-base text-white/70 mt-1">
            Acompanhe aqui os próximos eventos em tempo real da plataforma.
        </p>
    </div>

    <!-- Cartão de estado vazio -->
    <div class="flex-1 flex items-center justify-center px-6 md:px-16 py-10">
        <div
            class="w-full max-w-3xl rounded-2xl bg-[#232323]/80 border border-white/10 shadow-xl p-8 md:p-12 text-center">

            <div class="mx-auto flex items-center justify-center h-16 w-16 rounded-2xl bg-white/10">
                <mat-icon svgIcon="mat_outline:live_tv"></mat-icon>
            </div>

            <div class="inline-flex items-center gap-2 mt-6 px-3 py-1 rounded-full bg-white/10 border border-white/10">
                <span class="h-2 w-2 rounded-full bg-[#E4811E]"></span>
                <span class="text-xs uppercase tracking-wide text-white/80">Em breve</span>
            </div>

            <h2 class="mt-4 text-xl md:text-2xl font-semibold">
                Sem aulas ao vivo acontecendo no momento
            </h2>
            <p class="mt-2 text-white/70 leading-relaxed max-w-xl mx-auto">
                Fique tranquilo: você será avisado por e-mail sempre que tivermos
                uma nova aula ao vivo agendada.
            </p>

            <!-- Linha decorativa -->
            <div class="mt-8 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent"></div>

            <!-- Rodapé informativo -->
            <div class="mt-6 text-xs md:text-sm text-white/60">
                Dica: mantenha seu e-mail atualizado no seu perfil para receber os convites.
            </div>
        </div>
    </div>
</div>